import styles from './form.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    custom?: boolean;
}

export function FormGrid({children, custom}: OwnProps) {
    return (
        <div className={styles.form__grid}>
            <div
                className={classNames({
                    [styles.grid__default]: !custom,
                    [styles.grid__custom]: custom,
                })}
            >
                {children}
            </div>
        </div>
    );
}
